import React from "react";
var __jsx = React.createElement;
import { InfoScreen } from "@/pages/checkout/bnpl/common/components/InfoScreen";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { useDhamenContext } from "@/common/Contexts/DhamenContextProvider";
import ExpiredIcon from "@/pages/checkout/dhamen/icons/ExpiredIcon";
import { DHAMEN_STATUS } from "@/pages/checkout/dhamen/constants";
function OfferExpired() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useDhamenContext = useDhamenContext(),
    state = _useDhamenContext.state,
    actions = _useDhamenContext.actions;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InfoScreen, {
    icon: /*#__PURE__*/React.createElement(ExpiredIcon, null),
    title: tShort("dhamen/offer_expired_title"),
    text: tShort("dhamen/offer_expired_text"),
    primaryButton: {
      label: tShort("dhamen/start_new_request"),
      onClick: function onClick() {
        navigateTo("/site/dhamen/".concat(state.orderInfo.uuid, "?tab=user-info-form&status=").concat(DHAMEN_STATUS.NEW));
        actions.setStatus(DHAMEN_STATUS.NEW);
      }
    },
    secondaryButton: {
      label: tShort("dhamen/back_to_home"),
      onClick: function onClick() {
        return navigateTo("/");
      }
    }
  }));
}
export default OfferExpired;